import { useEffect, useState } from 'react';
import { API_BASE_URL, mediaUrl } from './config';
import { formatCurrency } from './currency';
import { IconHeartFilled, IconArrowRight } from './Icons';

// Public, unauthenticated view of someone else's wishlist via a share link
// (see POST/GET /api/wishlist/share[d/:token] and WishlistPage.js's Share
// Wishlist button). Read-only for the viewer except for adding items to
// their own cart.
export default function SharedWishlistPage({ token, onAddToCart, onNavigateToProduct }) {
  const [state, setState] = useState({ loading: true, error: null, ownerName: '', products: [] });

  useEffect(() => {
    let cancelled = false;
    setState({ loading: true, error: null, ownerName: '', products: [] });
    fetch(`${API_BASE_URL}/api/wishlist/shared/${token}`)
      .then(async (res) => {
        const data = await res.json();
        if (!res.ok) throw new Error(data.error || 'This wishlist link is invalid or no longer available.');
        return data;
      })
      .then((data) => { if (!cancelled) setState({ loading: false, error: null, ownerName: data.ownerName, products: data.products }); })
      .catch((err) => { if (!cancelled) setState({ loading: false, error: err.message, ownerName: '', products: [] }); });
    return () => { cancelled = true; };
  }, [token]);

  if (state.loading) {
    return <div className="wl-page"><p style={{ textAlign: 'center', padding: '60px 20px', color: 'var(--text-secondary)' }}>Loading wishlist…</p></div>;
  }

  if (state.error) {
    return (
      <div className="wl-page">
        <div className="wl-empty">
          <div className="wl-empty-icon"><IconHeartFilled size={32} /></div>
          <h3>Wishlist not found</h3>
          <p>{state.error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="wl-page">
      <div className="wl-header">
        <div className="wl-header-title">
          <div className="wl-icon-wrap"><IconHeartFilled size={22} /></div>
          <div>
            <h1 className="wl-title">{state.ownerName}'s Wishlist</h1>
            <p className="wl-subtitle">Shared with you from AcyMart</p>
          </div>
        </div>
      </div>

      {state.products.length === 0 ? (
        <div className="wl-empty">
          <h3>This wishlist is empty</h3>
          <p>Nothing has been added here yet.</p>
        </div>
      ) : (
        <div className="pcard-grid">
          {state.products.map((product) => {
            const isOos = product.stock === 0;
            return (
              <article key={product.id} className={`pcard${isOos ? ' pcard-oos' : ''}`} onClick={() => onNavigateToProduct?.(product.id)}>
                <div className="pcard-top">
                  <div className="pcard-img-wrap">
                    <img src={mediaUrl(product.image)} alt={product.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  </div>
                </div>
                <div className="pcard-body">
                  <h3 className="pcard-title">{product.name}</h3>
                  <div className="pcard-price-row">
                    <span className="pcard-price">{formatCurrency(product.salePrice ?? product.price)}</span>
                  </div>
                  <button
                    className="pcard-add-cart-btn"
                    type="button"
                    disabled={isOos}
                    onClick={(e) => { e.stopPropagation(); onAddToCart?.(product); }}
                  >
                    {isOos ? 'Out of Stock' : <>Add to Cart <IconArrowRight size={13} /></>}
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      )}
    </div>
  );
}
